export { default as FollowLinkArrow } from './FollowLinkArrow.svg';
export const AboutUsCoverEn = 'https://website-images.sylndr.com/AboutUsCoverEn.png';
export const AboutUsAr = 'https://website-images.sylndr.com/AboutUsAr.png';
export { default as SlickArrow } from './slickArrow.svg';
export * from './company-logos';
